import { getListAtMentionsSpacesQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { listAtMentionSpaces } from '#pplx/frontend/apps/ask/queries/spaces-queries/listAtMentionSpaces.js';
import { convertEmojiCodeToEmoji } from '#pplx/frontend/apps/ask/shared-helpers/stringUtils.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useCallback, useMemo, useState } from 'react';
export function useAtMentionSpaces({ reason, isLazy = true, enabled = true, }) {
    const [isTriggered, setIsTriggered] = useState(() => !isLazy);
    const { data, isLoading, isStale, refetch } = useQuery({
        queryKey: getListAtMentionsSpacesQueryKey(),
        queryFn: () => listAtMentionSpaces({ reason }),
        enabled: enabled && isTriggered,
        staleTime: 10 * 60 * 1000,
    });
    const onTrigger = useCallback(() => {
        if (!isTriggered) {
            setIsTriggered(true);
        }
        else if (isStale) {
            refetch();
        }
    }, [isTriggered, isStale, refetch]);
    const mentionSpacesOptions = useMemo(() => {
        const atMentionSpaces = data?.spaces ?? [];
        return atMentionSpaces.map((space) => ({
            uuid: space.uuid,
            variant: 'space',
            label: space.title,
            icon: getMentionSpaceIcon(space),
        }));
    }, [data]);
    return useMemo(() => ({
        isAtMentionSpacesEnabled: enabled,
        mentionSpacesOptions,
        isLoading,
        onTrigger,
    }), [enabled, isLoading, mentionSpacesOptions, onTrigger]);
}
function getMentionSpaceIcon(space) {
    if (space.emoji) {
        const emojiChar = convertEmojiCodeToEmoji(space.emoji);
        if (emojiChar) {
            return { type: 'emoji', char: emojiChar };
        }
    }
    return { type: 'icon', icon: $icon('folder') };
}
//# sourceMappingURL=useAtMentionSpaces.js.map